export const HEX_COLOR_FORMAT = "hex";
export const RGBA_COLOR_FORMAT = "rgba";

export const COLOR_FORMATS = [HEX_COLOR_FORMAT, RGBA_COLOR_FORMAT] as const;
